import { render, staticRenderFns } from "./ArtistsPlaylist.vue?vue&type=template&id=65864df6&scoped=true"
import script from "./ArtistsPlaylist.vue?vue&type=script&lang=js"
export * from "./ArtistsPlaylist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65864df6",
  null
  
)

export default component.exports